<template>
  <div>
    <b-row class="m-0">
      <b-col class="p-0">
        <div class="card bg-light mb-0">
          <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
              <h6 class="mb-0"><font-awesome-icon icon="list" /> Labor Usage</h6>
              <b-button variant="secondary" size="sm" @click="modal=true">
                  <font-awesome-icon icon="plus" /> Add New
              </b-button>
          </div>
          <div class="card-body bg-white position-relative">
            <b-row align-v="center" class="loader" v-if="is_saving">
                <b-col>
                    <b-spinner></b-spinner>
                    <br><br>
                    <strong>Loading</strong>
                </b-col>
            </b-row>
            <table class="table table-bordered mb-0">
              <thead class="bg-light text-dark">
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col" class="text-center">Job Description</th>
                  <th scope="col" class="text-center">Daily Rate</th>
                  <th scope="col" class="text-center">Regular Hours</th>
                  <th scope="col" class="text-center">OT Hours</th>
                  <th scope="col" class="text-center">ND Hours</th>
                  <th scope="col" class="text-center">Total</th>
                  <th scope="col" class="text-center">Action </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(manpower_usage, index) in manpower_usages">
                  <th scope="row">{{manpower_usage.manpower.full_name}}<b-badge v-if="!manpower_usage.is_manual" variant="info" class="text-white ml-2">System Generated</b-badge></th>
                  <th scope="row">{{manpower_usage.job_description.description}}</th>
                  <td class="text-right"><number-format-component :input_value="Number(manpower_usage.daily_rate)"/></td>
                  <td class="text-right"><number-format-component :input_value="Number(manpower_usage.regular_hours)" :currency="false"/></td>
                    <td class="text-right"><number-format-component :input_value="Number(manpower_usage.ot_hours)" :currency="false"/></td>
                    <td class="text-right"><number-format-component :input_value="Number(manpower_usage.nd_hours)" :currency="false"/></td>
                  <td class="text-right"><number-format-component :input_value="Number(manpower_usage.total)"/></td>
                  <td class="text-center">
                      <b-button type="submit" size="sm" variant="danger" @click="deleteItem(manpower_usage.id)"><font-awesome-icon icon="minus-circle" /> Remove</b-button>
                      <b-button type="submit" size="sm" variant="primary" class="ml-1" v-if="!manpower_usage.is_manual" @click="getLog(manpower_usage.id)"><font-awesome-icon icon="list" /> View Log</b-button>
                  </td>
                </tr>
              </tbody>
              <tfoot class="bg-light text-dark">
                <tr>
                  <th scope="col" class="text-right" colspan="6">TOTAL</th>
                  <th scope="col" class="text-right"><number-format-component :input_value="Number(total_usage)"/></th>
                  <th scope="col" class="text-center"></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </b-col>
    </b-row>
      <b-modal v-model="modal" centered size="xl" body-class="p-0" :hide-footer="true" :hide-header="true">
          <div class="card bg-light mb-0">
              <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                  <h6 class="mb-0"><font-awesome-icon icon="plus-circle" /> Labor Usage</h6>
              </div>
              <div class="card-body bg-white position-relative">
                  <b-row align-v="center" class="loader" v-if="modal_is_saving">
                      <b-col>
                          <b-spinner></b-spinner>
                          <br><br>
                          <strong>Loading</strong>
                      </b-col>
                  </b-row>
                  <table class="table border">
                      <thead class="bg-light text-dark">
                      <tr>
                          <th scope="col">Name</th>
                          <th scope="col" class="text-center">Job Description</th>
                          <th scope="col" class="text-center">Daily Rate</th>
                          <th scope="col" class="text-center">Regular Hours</th>
                          <th scope="col" class="text-center">OT Hours</th>
                          <th scope="col" class="text-center">ND Hours</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(project_location_structure_item_manpower, index) in project_location_structure_item_manpowers" v-if="project_location_structure_item_manpower.manpower!=null">
                          <th scope="row">{{project_location_structure_item_manpower.manpower.full_name}}</th>
                          <td>
                              <select class="form-control" v-model="project_location_structure_item_manpower.job_description_id" required>
                                  <option value="">Please Select</option>
                                  <option v-for="job_description in job_descriptions" :value="job_description.id">
                                      {{job_description.description}}
                                  </option>
                              </select>
                          </td>
                          <td>
                              <b-form-input
                                      v-model="project_location_structure_item_manpower.daily_rate"
                                      type="text"
                                      step="any"
                                      required
                              ></b-form-input>
                          </td>
                          <td>
                              <b-form-input
                                      v-model="project_location_structure_item_manpower.regular_hours"
                                      type="text"
                                      placeholder="H:MM"
                                      inputmode="numeric"
                                      pattern="[0-9]{1,2}:[0-9]{1,2}"
                                      required
                              ></b-form-input>
                          </td>
                          <td>
                              <b-form-input
                                      v-model="project_location_structure_item_manpower.ot_hours"
                                      type="text"
                                      placeholder="H:MM"
                                      inputmode="numeric"
                                      pattern="[0-9]{1,2}:[0-9]{1,2}"
                                      step="any"
                                      required
                              ></b-form-input>
                          </td>
                          <td>
                              <b-form-input
                                      v-model="project_location_structure_item_manpower.nd_hours"
                                      type="text"
                                      placeholder="H:MM"
                                      inputmode="numeric"
                                      pattern="[0-9]{1,2}:[0-9]{1,2}"
                                      step="any"
                                      required
                              ></b-form-input>
                          </td>
                      </tr>
                      </tbody>
                  </table>
                  <div class="text-right">
                      <b-button type="submit" variant="dark" size="sm" @click="save()"><font-awesome-icon icon="save" /> Save</b-button>
                  </div>
              </div>
          </div>
      </b-modal>
      <b-modal v-model="log_modal" centered size="xl" body-class="p-0" :hide-footer="true" :hide-header="true">
          <div class="card bg-light mb-0">
              <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                  <h6 class="mb-0"><font-awesome-icon icon="list" /> Employee Time Log</h6>
              </div>
              <div class="card-body bg-white position-relative" v-if="typeof log_details.am_in !='undefined'">
                  <b-row>
                      <b-col cols="6">
                          <div class="card bg-light mb-0">
                              <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                  <h6 class="mb-0">AM IN : {{log_details.formatted_am_in.other_formats.format_1}}</h6>
                              </div>
                              <div class="card-body bg-white position-relative">
                                  <template v-if="log_details.am_in!=null">
                                      <img
                                              class="cursor-pointer"
                                              :src="assets_path.EMPLOYEE_LOGS_URL+log_details.am_in_image"
                                              width="100%"
                                      />
                                  </template>
                              </div>
                          </div>
                      </b-col>
                      <b-col cols="6">
                          <div class="card bg-light mb-0">
                              <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                  <h6 class="mb-0">AM OUT : {{log_details.formatted_am_out.other_formats.format_1}}</h6>
                              </div>
                              <div class="card-body bg-white position-relative">
                                  <template v-if="log_details.am_out!=null">
                                      <img
                                              class="cursor-pointer"
                                              :src="assets_path.EMPLOYEE_LOGS_URL+log_details.am_out_image"
                                              width="100%"
                                      />
                                  </template>
                              </div>
                          </div>
                      </b-col>
                  </b-row>
                  <b-row class="mt-2">
                      <b-col cols="6">
                          <div class="card bg-light mb-0">
                              <div class="card-header bg-warning text-white d-flex justify-content-between align-items-center">
                                  <h6 class="mb-0">PM IN : {{log_details.formatted_pm_in.other_formats.format_1}}</h6>
                              </div>
                              <div class="card-body bg-white position-relative">
                                  <template v-if="log_details.pm_in!=null">
                                      <img
                                              class="cursor-pointer"
                                              :src="assets_path.EMPLOYEE_LOGS_URL+log_details.pm_in_image"
                                              width="100%"
                                      />
                                  </template>
                              </div>
                          </div>
                      </b-col>
                      <b-col cols="6">
                          <div class="card bg-light mb-0">
                              <div class="card-header bg-warning text-white d-flex justify-content-between align-items-center">
                                  <h6 class="mb-0">PM OUT : {{log_details.formatted_pm_out.other_formats.format_1}}</h6>
                              </div>
                              <div class="card-body bg-white position-relative">
                                  <template v-if="log_details.pm_out!=null">
                                      <img
                                              class="cursor-pointer"
                                              :src="assets_path.EMPLOYEE_LOGS_URL+log_details.pm_out_image"
                                              width="100%"
                                      />
                                  </template>
                              </div>
                          </div>
                      </b-col>
                  </b-row>
                  <b-row class="mt-2">
                      <b-col cols="6">
                          <div class="card bg-light mb-0">
                              <div class="card-header bg-info text-white d-flex justify-content-between align-items-center">
                                  <h6 class="mb-0">OT IN : {{log_details.formatted_ot_in.other_formats.format_1}}</h6>
                              </div>
                              <div class="card-body bg-white position-relative">
                                  <template v-if="log_details.ot_in!=null">
                                      <img
                                              class="cursor-pointer"
                                              :src="assets_path.EMPLOYEE_LOGS_URL+log_details.ot_in_image"
                                              width="100%"
                                      />
                                  </template>
                              </div>
                          </div>
                      </b-col>
                      <b-col cols="6">
                          <div class="card bg-light mb-0">
                              <div class="card-header bg-info text-white d-flex justify-content-between align-items-center">
                                  <h6 class="mb-0">OT OUT : {{log_details.formatted_ot_out.other_formats.format_1}}</h6>
                              </div>
                              <div class="card-body bg-white position-relative">
                                  <template v-if="log_details.ot_out!=null">
                                      <img
                                              class="cursor-pointer"
                                              :src="assets_path.EMPLOYEE_LOGS_URL+log_details.ot_out_image"
                                              width="100%"
                                      />
                                  </template>
                              </div>
                          </div>
                      </b-col>
                  </b-row>
              </div>
          </div>
      </b-modal>
  </div>
</template>
<script>
    import SwalMixin from '@/views/mixins/Swal.js'
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    import {assets_path} from '@/config';
    export default {
      mixins:[SwalMixin],
      components: {NumberFormatComponent},
      props:{
          manpower_usages: {
              type: Array,
              default: () => [],
              required:false
          },
          project_location_structure_item_manpowers: {
              type: Array,
              default: () => [],
              required:false
          },
          daily_log_id: {
              type: Number,
              required:false
          }
      },
      computed: {
          total_usage(){
              return this.manpower_usages.reduce((total, value)=>{
                return total + Number(value.total);
              },0);
          },
      },
      data() {
        return {
            assets_path:assets_path,
          is_saving:false,
          modal_is_saving:false,
          job_descriptions:[],
          modal:false,
            log_modal:false,
            log_details:{}
        }
      },
      watch: {
        manpower_usages:{
            immediate: true,
            deep:true,
            handler(){
                //this.get();
            }
        },
        project_location_structure_item_manpowers:{
            immediate: true,
            deep:true,
            handler(){
                //this.get();
            }
        }
      },
      created(){
        this.getFields();
      },
      methods: {
        save(){
          event.preventDefault();
          this.swalConfirmSubmit((data)=>{
              if (data.value) {
                this.modal_is_saving=true;
                let form = {
                  project_location_structure_item_manpowers:this.project_location_structure_item_manpowers,
                  daily_log_id:this.daily_log_id
                }
                this.axios.post('daily_log/manpower_usages/save',form).then(response => {
                    this.swalTransactionCompleted();
                    this.modal_is_saving=false;
                    this.modal=false;
                    this.$emit('addLabor');
                }).catch(error => {
                    this.swal_transaction_error_data.text = error.response.data;
                    this.swalRequestError();
                    this.modal_is_saving=false;
                });
              }
          });
        },
        getFields(){
          this.is_saving=true;
          this.axios.get('maintenance/job_descriptions/all').then(response => {
              this.job_descriptions = response.data;
              this.is_saving=false;
          }).catch(error => console.log(error));
        },
        deleteItem(id){
          this.swalConfirmDelete((data)=>{
              if (data.value) {
                this.is_saving=true;
                this.axios.delete('daily_log/manpower_usages/delete',{ data: {id:id} }).then(response => {
                    this.swalTransactionCompleted();
                    this.is_saving=false;
                    this.$emit('addLabor');
                }).catch(error => {
                    this.swal_transaction_error_data.text = error.response.data;
                    this.swalRequestError();
                    this.is_saving=false;
                });
              }
          });
          
        },
        getLog(id){
            this.log_modal=true;
            this.axios.get('daily_log/manpower_usages/get_log',{ params: { id:id } }).then(response => {
                this.log_details = response.data;
            }).catch(error => console.log(error));
        }
      }
    }
</script>
